module.exports = __webpack_public_path__ + "static/media/mar_bennasar3.167e48e3.jpg";